import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';
import { space, SpaceProps } from 'styled-system';

export const StyledHeader = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1.4fr 1fr;

  &:not(:last-child) {
    margin-bottom: 14px;
  }
`;

export const StyledWrapper = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 2fr;
  grid-gap: 32px;
`;

export const StyledSection = styled.section<SpaceProps>`
  overflow: hidden;
  width: 100%;
  padding: 24px 24px 46px 24px;
  border-radius: ${themeGet('radii.base')};
  box-shadow: ${themeGet('shadows.section')};
  background-color: ${themeGet('colors.white')};

  ${space};
`;

export const StyledHeading = styled.h5`
  margin-bottom: 27px;
  line-height: 27px;
  color: ${themeGet('colors.primary.regular')};
`;

export const StyledHeadingModify = styled(StyledHeading)`
  line-height: 24px;
  margin-bottom: 44px;

  span {
    margin-right: 14px;
    color: ${themeGet('colors.text.default')};
  }
`;

export const StyledList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
`;

export const StyledListItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 37px 0;
  line-height: ${themeGet('lineHeights.body')};
  font-size: ${themeGet('fontSizes.sm')}px;
  color: ${themeGet('colors.text.default')};

  &:not(:last-child) {
    border-bottom: 1px solid ${themeGet('colors.text.border')};
  }

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }
`;

export const StyledItemText = styled.span`
  display: flex;
  align-items: center;
  width: 50%;

  .custom-tooltip {
    margin-left: 10px;
  }
`;

export const StyledValue = styled.span`
  padding-left: 25px;
  width: 50%;

  &.status--success {
    color: ${themeGet('colors.primary.regular')};
  }

  &.status--closed {
    color: ${themeGet('colors.input.textError')};
  }
`;

export const StyledItemModify = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: ${themeGet('lineHeights.body')};
  font-size: ${themeGet('fontSizes.sm')}px;
  color: ${themeGet('colors.text.default')};

  &:not(:last-child) {
    margin-bottom: 34px;
  }

  ${StyledItemText} {
    font-weight: ${themeGet('fontWeights.semi')};
  }
`;

export const StyledText = styled.span`
  width: 50%;
  color: ${themeGet('colors.primary.regular')};
`;

export const StyledGridContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
`;

export const StyledPanel = styled.div`
  padding: 27px 24px 27px 14px;
  width: 100%;
  border-radius: 6px;
  background-color: ${themeGet('colors.primary.regular')};

  h6 {
    color: ${themeGet('colors.white')};
    font-weight: ${themeGet('fontWeights.bold')};
    font-size: ${themeGet('fontSizes.sm')}px;

    &:not(:last-child) {
      margin-bottom: 22px;
    }
  }
`;

export const StyledPanelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledPanelSign = styled.span`
  display: flex;
  align-items: center;
  color: ${themeGet('colors.white')};
  font-weight: ${themeGet('fontWeights.bold')};
  font-size: ${themeGet('fontSizes.xs')}px;

  svg {
    margin-right: 6px;
  }
`;

export const StyledPanelValue = styled.span`
  display: block;
  width: 79px;
  padding: 5px 7px;
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  border-color: ${themeGet('colors.text.border')};
  background-color: ${themeGet('colors.white')};
  color: ${themeGet('colors.input.text')};
  font-weight: ${themeGet('fontWeights.bold')};
  font-size: ${themeGet('fontSizes.sm')}px;
`;
